import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SilkierExceptionMessageVm } from 'app/shared/generated/Silkier/Models/SilkierExceptionMessageVm'
@Component({
    selector: 'pcg-view-exception-modal',
    templateUrl: './view-exception-modal.component.html',
    styleUrls: ['./view-exception-modal.component.scss'],
    standalone: false
})
export class ViewExceptionModalComponent implements OnInit {
    private destroyRef = inject(DestroyRef);
    id: number;
    exceptionMsg: string;
    constructor(public modal: NgbActiveModal, private httpClient: HttpClient) { }
    ngOnInit() { this.getException() }
    public getException() {
        const httpParams = new HttpParams().set('fireInstanceId', this.id);
        this.httpClient.get('api/Silkier/SilkierHistory/GetException', {
            params: httpParams,
        }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((resp : SilkierExceptionMessageVm) => {
            if (resp != null) { this.exceptionMsg = resp.exceptionMessage; }
        })
    }
}
